import React from 'react';
import moment from 'moment';
import { toastr } from 'react-redux-toastr';
import { DateRangePicker } from 'react-dates';
import DatePickerZ from '../../commons/datePicker/datePicker';
import InputField from '../../commons/formElements/inputField/inputField';
import Modal from '../../commons/modal/modal';
import Select from '../../commons/formElements/select/select';
import UploadIcon from '../../../assets/images/outline-cloud_upload-24px.svg';
import cancel from '../../../assets/images/red-cross.svg';
import styles from './addNewVehicle.scss';
import Loader from '../../commons/loader/loader';
import {
  maximumVehicleExtraImagesCount,
  vehicleDataFieldAndErrorList,
  minimumVehicleDateTimeStamp
} from './manageVehiclesHelper';

type Props = {
  showModal: boolean,
  closeModal: Function,
  title: string
};

type State = {
  showPopover: boolean
};

const VehicleTypeEnum = {
  SELF: 'SELF',
  MARKET: 'MARKET'
};

class AddNewVehicle extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {};

    this.sizeNameValStrings = { nameKey: 'label', valKey: 'id' };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.toEditVehicle !== null) {
      if (
        this.props.toEditVehicle &&
        nextProps.toEditVehicle.id === this.props.toEditVehicle.id
      ) {
        return;
      }

      const selectedVehicleType = this.props.vehicleTypesOptions.find(
        item => item.id === nextProps.toEditVehicle.vehicleTypeId
      );

      const vehicleBodyTypeData = {
        label:
          nextProps.toEditVehicle && nextProps.toEditVehicle.vehicleBodyType,
        val: nextProps.toEditVehicle && nextProps.toEditVehicle.vehicleBodyType
      };

      const purchaseMonthAndYearData =
        nextProps.toEditVehicle && nextProps.toEditVehicle.purchaseMonthAndYear;

      const dateObj = nextProps.toEditVehicle.availableFrom
        ? {
            startDate: moment(nextProps.toEditVehicle.availableFrom),
            endDate: moment(nextProps.toEditVehicle.availableTo)
          }
        : {};

      const vehicleAvailabilityStatus =
        nextProps.toEditVehicle &&
        nextProps.toEditVehicle.vehicleAvailabilityStatus;

      this.setState({
        ...nextProps.toEditVehicle,
        ...dateObj,
        selectedVehicleType,
        vehicleBodyTypeData,
        purchaseMonthAndYearData,
        vehicleAvailabilityStatus
      });
    } else if (
      nextProps.newVehicleAdded !== null &&
      nextProps.newVehicleAdded !== this.props.newVehicleAdded
    ) {
      this.reset();
    }
  }

  reset() {
    const keys = Object.keys(this.state);
    const stateReset = keys.reduce(
      (acc, v) => ({ ...acc, [v]: undefined }),
      {}
    );
    this.setState({ ...stateReset });
  }

  getVehicleBodyTypeList = [
    {
      label: 'OPEN',
      val: 'OPEN'
    },
    {
      label: 'CLOSED',
      val: 'CLOSED'
    }
  ];

  onInputChange = (field, val) => {
    if (field === 'vehicleNumber') {
      val = val && val.toUpperCase();
    }
    this.setState({ [field]: val });
    if (
      field === 'ownerType' &&
      val === 'SELF' &&
      !this.props.toEditVehicle &&
      !this.state.ownerName
    ) {
      this.setState({
        ownerName: this.props.filters.vendorName
      });
    } else if (
      field === 'ownerType' &&
      val === 'MARKET' &&
      !this.props.toEditVehicle
    ) {
      this.setState({
        ownerName: ''
      });
    }
  };

  /**
   * isDataValid: Perform form data validations before api call
   *
   * @param data
   * @returns {boolean}
   */
  isDataValid = data => {
    let isValid = true;

    (vehicleDataFieldAndErrorList || []).forEach(field => {
      if (isValid && !data[field.fieldName]) {
        isValid = false;
        toastr.error('Error', field.errorMessage);
      }
    });

    return isValid;
  };

  /**
   * getVehicleImagesData: add vehicle and rc images to data object
   *
   */
  getVehicleImagesData = data => {
    const { uploadedFiles } = this.props;
    const postData = { ...data };

    if (uploadedFiles) {
      postData.rcFrontS3Url = uploadedFiles.rcFrontS3Url || null;
      postData.rcBackS3Url = uploadedFiles.rcBackS3Url || null;
      postData.vehicleFrontViewS3Url =
        uploadedFiles.vehicleFrontViewS3Url || null;
      postData.vehicleRearViewS3Url =
        uploadedFiles.vehicleRearViewS3Url || null;
      postData.vehicleRightViewS3Url =
        uploadedFiles.vehicleRightViewS3Url || null;
      postData.vehicleLeftViewS3Url =
        uploadedFiles.vehicleLeftViewS3Url || null;
    }

    return postData;
  };

  addNewVehicle = () => {
    const vehicleS3Urls = this.props.vehicleS3Urls || [];

    let postData = {
      ownerName: this.state.ownerName,
      ownerType: this.state.ownerType,
      availableFrom: this.state.availableFrom,
      availableTo: this.state.availableTo,
      registrationNumber: this.state.registrationNumber,
      vehicleNumber: this.state.vehicleNumber,
      vehicleTypeId: this.state.vehicleTypeId,
      vehicleS3Urls,
      vehicleBodyType: this.state.vehicleBodyType,
      purchaseMonthAndYear: this.state.purchaseMonthAndYear,
      vehicleAvailabilityStatus: this.state.vehicleAvailabilityStatus,
      ...this.props.filters
    };

    postData = this.getVehicleImagesData(postData);

    if (postData.ownerType === VehicleTypeEnum.SELF) {
      delete postData.availableFrom;
      delete postData.availableTo;
    }

    if (this.state.id && this.props.toEditVehicle.status === 'CREATED') {
      postData.id = this.state.id;
      postData.vehicleLegType = this.state.vehicleLegType;
      postData.vehiclePartnerType = this.state.vehiclePartnerType;
      if (this.isDataValid(postData)) {
        this.props.updateVehicleData(postData);
      }
    } else {
      postData.vehicleLegType =
        this.state.vehicleLegType || this.props.filters.legType;
      postData.vehiclePartnerType =
        this.state.vehiclePartnerType || this.props.filters.partnerType;
      if (this.isDataValid(postData)) {
        this.props.addNewVehicle(postData);
      }
    }
  };

  handleDateChange = (startDate, endDate) => {
    const availableFrom = new Date(startDate).getTime();
    const availableTo = new Date(endDate).getTime();
    this.setState({
      availableFrom,
      availableTo,
      startDate,
      endDate
    });
  };

  handleImageChange(e, fileType) {
    e.preventDefault();

    const file = e.target.files[0];
    this.props.uploadImage(fileType, file, this.state.vehicleNumber, () => {
      if (fileType === 'rcFrontS3Url') {
        document.getElementById('rc-front').value = '';
      } else if (fileType === 'rcBackS3Url') {
        document.getElementById('rc-back').value = '';
      } else if (fileType === 'vehicleFrontViewS3Url') {
        document.getElementById('vehicle-front').value = '';
      } else if (fileType === 'vehicleRearViewS3Url') {
        document.getElementById('vehicle-rear').value = '';
      } else if (fileType === 'vehicleRightViewS3Url') {
        document.getElementById('vehicle-right').value = '';
      } else if (fileType === 'vehicleLeftViewS3Url') {
        document.getElementById('vehicle-left').value = '';
      } else {
        // do nothing
      }
    });
  }

  handleVehicleImagesUpload(e) {
    e.preventDefault();

    const { files } = e.target;
    if (files && files.length) {
      this.props.uploadVehicleImages(files[0], this.state.vehicleNumber, () => {
        document.getElementById('vehicle-images').value = '';
      });
    }
  }

  onModalClose = () => {
    this.reset();
    this.props.closeModal();
  };

  render() {
    const { isLoading, uploadedFiles } = this.props;
    const frontImagePreview =
      uploadedFiles && uploadedFiles.rcFrontS3Url
        ? uploadedFiles.rcFrontS3Url
        : null;
    const backImagePreview =
      uploadedFiles && uploadedFiles.rcBackS3Url
        ? uploadedFiles.rcBackS3Url
        : null;
    const vehicleFrontImagePreview =
      uploadedFiles && uploadedFiles.vehicleFrontViewS3Url
        ? uploadedFiles.vehicleFrontViewS3Url
        : null;
    const vehicleRearImagePreview =
      uploadedFiles && uploadedFiles.vehicleRearViewS3Url
        ? uploadedFiles.vehicleRearViewS3Url
        : null;
    const vehicleRightImagePreview =
      uploadedFiles && uploadedFiles.vehicleRightViewS3Url
        ? uploadedFiles.vehicleRightViewS3Url
        : null;
    const vehicleLeftImagePreview =
      uploadedFiles && uploadedFiles.vehicleLeftViewS3Url
        ? uploadedFiles.vehicleLeftViewS3Url
        : null;

    const vehicleS3Urls = this.props.vehicleS3Urls
      ? this.props.vehicleS3Urls
      : [];

    return (
      <Modal
        showModal={this.props.showModal}
        title={this.props.title}
        closeModal={() => {
          this.onModalClose();
        }}
      >
        <div className={styles.addNewVehicleContainer}>
          {isLoading ? (
            <div className={styles.loader}>
              <Loader />{' '}
            </div>
          ) : null}

          <div className={styles.modalContainer}>
            {/* Vehicle Type field */}
            <div className={styles.formField}>
              <div className={`${styles.inputFieldCtr} `}>
                <div className={styles.radioGroup}>
                  {(this.props.filters || {}).partnerType !== 'RIVIGO' && (
                    <label
                      htmlFor="vehicleTypeOwned"
                      className={styles.radioButton}
                    >
                      <input
                        type="radio"
                        id="vehicleTypeOwned"
                        name="vehicleType"
                        className="is-hidden"
                        value="owned"
                        checked={this.state.ownerType === VehicleTypeEnum.SELF}
                        onChange={() => {
                          this.onInputChange('ownerType', VehicleTypeEnum.SELF);
                        }}
                      />
                      <span className={styles.label} />
                      Owned Vehicle
                    </label>
                  )}

                  <label
                    htmlFor="vehicleTypeMarket"
                    className={styles.radioButton}
                  >
                    <input
                      type="radio"
                      id="vehicleTypeMarket"
                      name="vehicleType"
                      className="is-hidden"
                      value="market"
                      checked={this.state.ownerType === VehicleTypeEnum.MARKET}
                      onChange={() => {
                        this.onInputChange('ownerType', VehicleTypeEnum.MARKET);
                      }}
                    />
                    <span className={styles.label} />
                    Market Vehicle
                  </label>
                </div>
              </div>
            </div>

            {this.state.ownerType && (
              <div>
                {/* Available from and to field */}
                {this.state.ownerType === VehicleTypeEnum.MARKET && (
                  <div className={styles.formField}>
                    <div className={styles.label}>Available From</div>
                    <div className={styles.datePickerInput}>
                      <DateRangePicker
                        showClearDates
                        minimumNights={0}
                        numberOfMonths={1}
                        startDate={this.state.startDate} // momentPropTypes.momentObj or null,
                        endDate={this.state.endDate} // momentPropTypes.momentObj or null,
                        onDatesChange={({ startDate, endDate }) =>
                          this.handleDateChange(startDate, endDate)
                        } // PropTypes.func.isRequired,
                        focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                        onFocusChange={focusedInput =>
                          this.setState({ focusedInput })
                        } // PropTypes.func.isRequired,
                        hideKeyboardShortcutsPanel={true}
                        isOutsideRange={
                          this.props.isOutsideRangeCheck
                            ? day => {
                                if (this.state.focusedInput === 'endDate') {
                                  // End date is after today and not before start date
                                  return (
                                    day.isBefore(
                                      moment(
                                        new Date(
                                          new Date().setHours(23, 59, 59, 999)
                                        )
                                      )
                                    ) || day.isBefore(this.state.startDate)
                                  );
                                }
                                if (this.state.focusedInput === 'startDate') {
                                  // Start date is on today or future date
                                  return day.isBefore(
                                    moment(new Date().setHours(0, 0, 0, 0))
                                  );
                                }

                                return false;
                              }
                            : () => false
                        }
                      />
                    </div>
                  </div>
                )}
                {/* Owner name field */}

                <div className={styles.formField}>
                  <div className={styles.label}>Owner Name</div>
                  <div className={styles.inputFieldCtr}>
                    <InputField
                      name="ownerName"
                      type="text"
                      placeholder="Please enter name"
                      onChange={val => this.onInputChange('ownerName', val)}
                      value={this.state.ownerName || ''}
                      disabled={false}
                      inputFieldWrapperClass={styles.inputFieldWrapper}
                      inputClassName={styles.inputField}
                    />
                  </div>
                </div>

                {/* Vehicle number field */}

                <div className={styles.formField}>
                  <div className={styles.label}>Vehicle Number</div>
                  <div className={styles.inputFieldCtr}>
                    <InputField
                      name="vehicleNumber"
                      type="text"
                      placeholder="Please enter vehicle number"
                      onChange={val => {
                        this.onInputChange('vehicleNumber', val);
                        this.props.deleteImageFile('rcFrontS3Url');
                        this.props.deleteImageFile('rcBackS3Url');
                        this.props.deleteImageFile('vehicleFrontViewS3Url');
                        this.props.deleteImageFile('vehicleRearViewS3Url');
                        this.props.deleteImageFile('vehicleRightViewS3Url');
                        this.props.deleteImageFile('vehicleLeftViewS3Url');
                        this.props.deleteVehicleImage(null, true);
                      }}
                      value={this.state.vehicleNumber || ''}
                      disabled={false}
                      inputFieldWrapperClass={styles.inputFieldWrapper}
                      inputClassName={styles.inputField}
                    />
                  </div>
                </div>

                {/* Size field */}

                <div className={styles.formField}>
                  <div className={styles.label}>Size (l, b, h) ft</div>
                  <div className={styles.inputFieldCtr}>
                    <Select
                      label="Size (l, b, h) ft"
                      selectedOpt={this.state.selectedVehicleType}
                      optionsArrOfObj={this.props.vehicleTypesOptions || []}
                      nameValStrings={this.sizeNameValStrings}
                      onSelect={(val, obj) => {
                        this.onInputChange('size', val);
                        this.onInputChange('vehicleTypeId', obj.id);
                        this.onInputChange('capacity', obj.maxWeight);
                      }}
                      disabled={false}
                      enableSearch={false}
                      disableNone={true}
                      selectedWrapperClass="select-field-wrapper white-background"
                      inputClassName={styles.inputField}
                    />
                  </div>
                </div>

                {/* vehicle body type and vehicle purchase date fields */}

                <div
                  className={styles.formField}
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between'
                  }}
                >
                  <div>
                    <div className={styles.label}>Body Type</div>
                    <div className={styles.inputFieldCtr}>
                      <Select
                        label="Open/Closed"
                        selectedOpt={this.state.vehicleBodyTypeData}
                        optionsArrOfObj={this.getVehicleBodyTypeList || []}
                        nameValStrings={{ nameKey: 'label', valKey: 'val' }}
                        onSelect={val => {
                          if (val && val !== this.state.vehicleBodyType) {
                            this.onInputChange('vehicleBodyType', val);
                          }
                        }}
                        disabled={false}
                        enableSearch={false}
                        disableNone={true}
                        selectedWrapperClass="select-field-wrapper white-background"
                        inputClassName={styles.inputField}
                      />
                    </div>
                  </div>

                  <div>
                    <div className={styles.label}>Vehicle Purchase Date</div>
                    <div
                      className={
                        (styles.datePickerInput, styles.monthYearPicker)
                      }
                    >
                      <DatePickerZ
                        id="datePicker"
                        name="Vehicle Purchase Date"
                        placeholderText="Month & Year"
                        startDate={
                          this.state.purchaseMonthAndYear ||
                          this.state.purchaseMonthAndYearData
                        }
                        minDate={minimumVehicleDateTimeStamp}
                        maxDate={new Date()}
                        dateFormat="MMM, yyyy"
                        onChange={date => {
                          this.onInputChange(
                            'purchaseMonthAndYear',
                            date.getTime()
                          );
                        }} // PropTypes.func.isRequired,
                        className={styles.monthYearPickerInput}
                        popperClassName={styles.popperStyle}
                        showMonthYearPicker
                      />
                    </div>
                  </div>
                </div>

                {/* Capacity field */}

                <div className={styles.formField}>
                  <div className={styles.label}>Capacity (kg)</div>
                  <div className={styles.inputFieldCtr}>
                    <InputField
                      name="capacity"
                      type="text"
                      placeholder="Please enter capacity"
                      onChange={val => this.onInputChange('capacity', val)}
                      value={this.state.capacity || ''}
                      disabled={true}
                      inputFieldWrapperClass={styles.inputFieldWrapper}
                      inputClassName={styles.inputField}
                    />
                  </div>
                </div>

                {/* RC File Upload field */}

                <div className={styles.formField}>
                  <div className={styles.label}>
                    Registration Certificate Image
                  </div>
                  <div className={styles.inputFieldCtr}>
                    <div className={styles.formInputFile}>
                      <div className={styles.fileUploadBox}>
                        <input
                          hidden
                          type="file"
                          id="rc-front"
                          onChange={e =>
                            this.handleImageChange(e, 'rcFrontS3Url')
                          }
                        />
                        <label className={styles.fileLabel} htmlFor="rc-front">
                          <span
                            className="pos-rel display-inline-block"
                            onClick={e => {
                              if (frontImagePreview) {
                                e.preventDefault();
                              }
                              this.props.deleteImageFile('rcFrontS3Url');
                            }}
                          >
                            <img
                              src={frontImagePreview || UploadIcon}
                              className={styles.uploadIcon}
                            />
                            {frontImagePreview && (
                              <img
                                src={cancel}
                                className={styles.statusImage}
                              />
                            )}
                          </span>
                          <span>Upload RC Front</span>
                        </label>
                      </div>
                      <div className={styles.fileUploadBox}>
                        <input
                          hidden
                          type="file"
                          id="rc-back"
                          onChange={e =>
                            this.handleImageChange(e, 'rcBackS3Url')
                          }
                        />
                        <label className={styles.fileLabel} htmlFor="rc-back">
                          <span
                            className="pos-rel display-inline-block"
                            onClick={e => {
                              if (backImagePreview) {
                                e.preventDefault();
                              }
                              this.props.deleteImageFile('rcBackS3Url');
                            }}
                          >
                            <img
                              src={backImagePreview || UploadIcon}
                              className={styles.uploadIcon}
                            />
                            {backImagePreview && (
                              <img
                                src={cancel}
                                className={styles.statusImage}
                              />
                            )}
                          </span>
                          <span>Upload RC Back</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Vehicle images upload field */}

                <div className={styles.formField}>
                  <div className={styles.label}>Vehicle Images</div>
                  <div className={styles.inputFieldCtr}>
                    <div className={styles.formInputFile}>
                      <div>
                        <div className={styles.flexWrapDiv}>
                          <div className={styles.fileUploadBox}>
                            <input
                              hidden
                              type="file"
                              id="vehicle-front"
                              onChange={e =>
                                this.handleImageChange(
                                  e,
                                  'vehicleFrontViewS3Url'
                                )
                              }
                            />
                            <label
                              className={styles.fileLabel}
                              htmlFor="vehicle-front"
                            >
                              <span
                                className="pos-rel display-inline-block"
                                onClick={e => {
                                  if (vehicleFrontImagePreview) {
                                    e.preventDefault();
                                  }
                                  this.props.deleteImageFile(
                                    'vehicleFrontViewS3Url'
                                  );
                                }}
                              >
                                <img
                                  src={vehicleFrontImagePreview || UploadIcon}
                                  className={styles.uploadIcon}
                                />
                                {vehicleFrontImagePreview && (
                                  <img
                                    src={cancel}
                                    className={styles.statusImage}
                                  />
                                )}
                              </span>
                              <span>Front View</span>
                            </label>
                          </div>
                          <div className={styles.fileUploadBox}>
                            <input
                              hidden
                              type="file"
                              id="vehicle-rear"
                              onChange={e =>
                                this.handleImageChange(
                                  e,
                                  'vehicleRearViewS3Url'
                                )
                              }
                            />
                            <label
                              className={styles.fileLabel}
                              htmlFor="vehicle-rear"
                            >
                              <span
                                className="pos-rel display-inline-block"
                                onClick={e => {
                                  if (vehicleRearImagePreview) {
                                    e.preventDefault();
                                  }
                                  this.props.deleteImageFile(
                                    'vehicleRearViewS3Url'
                                  );
                                }}
                              >
                                <img
                                  src={vehicleRearImagePreview || UploadIcon}
                                  className={styles.uploadIcon}
                                />
                                {vehicleRearImagePreview && (
                                  <img
                                    src={cancel}
                                    className={styles.statusImage}
                                  />
                                )}
                              </span>
                              <span>Rear View</span>
                            </label>
                          </div>
                          <div className={styles.fileUploadBox}>
                            <input
                              hidden
                              type="file"
                              id="vehicle-right"
                              onChange={e =>
                                this.handleImageChange(
                                  e,
                                  'vehicleRightViewS3Url'
                                )
                              }
                            />
                            <label
                              className={styles.fileLabel}
                              htmlFor="vehicle-right"
                            >
                              <span
                                className="pos-rel display-inline-block"
                                onClick={e => {
                                  if (vehicleRightImagePreview) {
                                    e.preventDefault();
                                  }
                                  this.props.deleteImageFile(
                                    'vehicleRightViewS3Url'
                                  );
                                }}
                              >
                                <img
                                  src={vehicleRightImagePreview || UploadIcon}
                                  className={styles.uploadIcon}
                                />
                                {vehicleRightImagePreview && (
                                  <img
                                    src={cancel}
                                    className={styles.statusImage}
                                  />
                                )}
                              </span>
                              <span>Right View</span>
                            </label>
                          </div>
                          <div className={styles.fileUploadBox}>
                            <input
                              hidden
                              type="file"
                              id="vehicle-left"
                              onChange={e =>
                                this.handleImageChange(
                                  e,
                                  'vehicleLeftViewS3Url'
                                )
                              }
                            />
                            <label
                              className={styles.fileLabel}
                              htmlFor="vehicle-left"
                            >
                              <span
                                className="pos-rel display-inline-block"
                                onClick={e => {
                                  if (vehicleLeftImagePreview) {
                                    e.preventDefault();
                                  }
                                  this.props.deleteImageFile(
                                    'vehicleLeftViewS3Url'
                                  );
                                }}
                              >
                                <img
                                  src={vehicleLeftImagePreview || UploadIcon}
                                  className={styles.uploadIcon}
                                />
                                {vehicleLeftImagePreview && (
                                  <img
                                    src={cancel}
                                    className={styles.statusImage}
                                  />
                                )}
                              </span>
                              <span>Left View</span>
                            </label>
                          </div>
                        </div>
                        {!this.state.isAddMoreEnabled && !vehicleS3Urls.length && (
                          <div className={styles.marginTop}>
                            <button
                              className={styles.smallActionButton}
                              onClick={() =>
                                this.setState({
                                  isAddMoreEnabled: !this.state.isAddMoreEnabled
                                })
                              }
                            >
                              +Add More
                            </button>
                          </div>
                        )}
                        {((vehicleS3Urls && vehicleS3Urls.length) ||
                          this.state.isAddMoreEnabled) && (
                          <div className={styles.marginTop}>
                            <div className={styles.fileUploadBox}>
                              <div className={styles.vehicleImagesContainer}>
                                {(vehicleS3Urls || []).map((item, index) => {
                                  return (
                                    <span
                                      key={index}
                                      style={{
                                        position: 'relative',
                                        display: 'inline-block'
                                      }}
                                      onClick={() => {
                                        this.props.deleteVehicleImage(index);
                                      }}
                                    >
                                      <img
                                        src={item}
                                        className={styles.uploadIcon}
                                      />
                                      <img
                                        src={cancel}
                                        className={styles.statusImage}
                                      />
                                    </span>
                                  );
                                })}
                                {(vehicleS3Urls || []).length <
                                  maximumVehicleExtraImagesCount && (
                                  <>
                                    <input
                                      hidden
                                      type="file"
                                      id="vehicle-images"
                                      onChange={e =>
                                        this.handleVehicleImagesUpload(e)
                                      }
                                    />
                                    <label
                                      style={{ display: 'initial' }}
                                      htmlFor="vehicle-images"
                                    >
                                      <img
                                        src={UploadIcon}
                                        className={styles.uploadIcon}
                                      />
                                    </label>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* SUBMIT Button */}
                <div
                  className={styles.actionButton}
                  onClick={() => this.addNewVehicle()}
                >
                  SAVE VEHICLE DETAIL
                </div>
              </div>
            )}
          </div>
        </div>
      </Modal>
    );
  }
}

export default AddNewVehicle;
